// Regras do valor de uma promoção (01/11/2026). As mesmas para produto,
// versão simples/combo e CADA tamanho de pizza: até aqui a pizza pulava a
// checagem e aceitava "por R$ 65,00" numa pizza de R$ 60,00 (saía "em
// promoção" mais cara) e 100 % de desconto (saía de graça).

const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

/**
 * Mensagem de erro do valor de UM item, ou null quando está bom.
 * `tipo`: "percentage" (desconto em %) ou "fixed_price" (preço que o cliente
 * paga). `precoNormal` desconhecido (0/undefined) → só a regra dos 100 % vale.
 */
export function erroDoValor({ tipo, valor, precoNormal, nome }) {
  const v = Number(valor);
  if (!Number.isFinite(v) || v <= 0) return `Defina o desconto para ${nome}`;
  if (tipo === "percentage" && v >= 100) return `O desconto de ${nome} precisa ser menor que 100%`;
  const base = Number(precoNormal);
  if (tipo === "fixed_price" && base > 0 && v >= base) {
    return `O preço de ${nome} na promoção precisa ser menor que ${reais(base)}`;
  }
  return null;
}

/**
 * Pizza: `sizes` = {tamanhoId: valor digitado}; `precos` = {tamanhoId: preço
 * normal}; `tamanhos` = itens do step "Tamanho" ({id, name}). Conta como
 * preenchido só o tamanho com número > 0 (os outros são ignorados, como ao
 * gravar); precisa de ao menos um, e cada preenchido passa por `erroDoValor`.
 */
export function erroDaPizza({ tipo, sizes, precos, tamanhos, nome }) {
  const preenchidos = Object.entries(sizes || {}).filter(([, v]) => Number(v) > 0);
  if (preenchidos.length === 0) return `Defina o desconto em ao menos 1 tamanho de ${nome}`;
  for (const [id, valor] of preenchidos) {
    const tamanho = (tamanhos || []).find((t) => t.id === id);
    const erro = erroDoValor({
      tipo, valor, precoNormal: precos?.[id],
      nome: tamanho?.name ? `${nome} (${tamanho.name})` : nome,
    });
    if (erro) return erro;
  }
  return null;
}
